import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import format from 'date-fns/format';
import classnames from 'classnames';
import { sorts, publisherOption, publisherValue, publisherLabel } from '../utils';
import { useQueryStringParam } from '../utils/routing';
import { getProviders } from './Providers';
import { Link } from 'react-router-dom';
import Input from '../components/form/FormikInput';
import MultiSelect from '../components/form/MultiSelect';
import Select from '../components/form/Select';
import AuthorList from '../components/title/AuthorList';
import Loading from '../components/Loading';
import Modal from '../components/Modal';
import TitleStatusButton from '../components/TitleStatusButton';
import { DateRangePicker } from 'react-dates';
import { Formik, useFormik } from 'formik';
import { object, string } from 'yup';
import { FaInfoCircle } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import Layout from '../pages/Layout';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Pagination from '../components/Pagination';

export const saveData = (function () {
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.style.display = 'none';
    return function (blob, fileName, cb) {
        var url = window.URL.createObjectURL(new Blob([blob]));
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        if (typeof cb === 'function') {
            setTimeout(cb, 500);
        }
    };
})();

export const getAllTitles = ({
    page = 1,
    per_page = 20,
    order_by = 'title:asc',
    download = null,
    vendors = null,
    q = null,
    status = null,
    release_date_0 = null,
    release_date_1 = null,
    pubs = null
}) => {
    return axios.request({
        url: `${process.env.REACT_APP_API_URL}/authorized/titles`,
        params: {
            page,
            per_page,
            order_by,
            download,
            pubs,
            vendors,
            q,
            status,
            release_date_0,
            release_date_1
        },
        method: 'GET'
    });
};
const getPubs = (vendor) => {
    return axios.request({
        url: `${process.env.REACT_APP_API_URL}/authorized/vendor/${vendor}/publishers/`,
        method: 'GET'
    });
};
export const addTitle = (data) => {
    return axios.request({
        url: `${process.env.REACT_APP_API_URL}/authorized/titles`,
        method: 'POST',
        data: { ...data, active: true, authors: [], narrators: [], drm_required: false }
    });
};

const Catalog = () => {
    const session = useSelector((state) => state.session);
    let [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    const [results, setResults] = useState([]);
    const [total, setTotal] = useState(0);
    const [showAddModal, setShowAddModal] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [page, setPage] = useState(1);
    const [providers, setProviders] = useState([]);
    const [publishers, setPublishers] = useState([]);
    const [pageCount, setPageCount] = useState();
    const perPage = 20;
    const [focusedInput, setFocusedInput] = useState();
    const history = useHistory();
    const [ranOnPageLoad, setRanOnPageLoad] = useState(false);
    const queryParamFilter = useQueryStringParam('statusFilter') || null;
    let preselectedStatus = [];

    if (queryParamFilter) {
        preselectedStatus = [
            { value: queryParamFilter, label: queryParamFilter.charAt(0).toUpperCase() + queryParamFilter.slice(1) }
        ];
    }

    const { values, setFieldValue, setValues } = useFormik({
        initialValues: {
            vendor: { value: session.selectedVendor, label: session.selectedVendorName } || {},
            search: '',
            status: preselectedStatus,
            releaseDateFrom: null,
            releaseDateTo: null,
            selectedPublishers: session.isAdmin && session?.user?.provider ? session.user.provider.publishers : []
        },
        enableReinitialize: true
    });

    useEffect(() => {
        const getProvidersAndPubs = async () => {
            if (session.isAdmin) {
                try {
                    let providers = await getProviders();

                    let res = await getPubs(session.selectedVendor);
                    setProviders(providers.results);
                    setPublishers(res?.data?.filter((pub) => pub) || []);
                } catch (err) {
                    console.error(err);
                    setProviders([]);
                    setPublishers([]);
                }
            }
        };
        getProvidersAndPubs();
    }, [session.isAdmin, session.selectedVendor]);

    const fetchTitles = useCallback(
        async (resultStartPage) => {
            setLoading(true);
            setError(false);
            let pubs = null;
            let tempStatus = '';
            if (values.selectedPublishers.length) {
                pubs = JSON.stringify(values.selectedPublishers);
            }
            if (values.status.length) {
                tempStatus = values.status.map((s) => s.value).join(',');
            }
            let orderBy = values.releaseDateFrom && values.releaseDateTo ? 'original_release_date:desc' : 'title:asc';
            let params = {
                page: resultStartPage,
                per_page: perPage,
                order_by: orderBy,
                pubs,
                q: values.search || null,
                status: tempStatus || null,
                release_date_0:
                    values.releaseDateFrom && values.releaseDateTo ? values.releaseDateFrom.format('YYYY-MM-DD') : null,
                release_date_1:
                    values.releaseDateFrom && values.releaseDateTo ? values.releaseDateTo.format('YYYY-MM-DD') : null
            };
            if (values.vendor?.value && values.vendor?.value !== 'All') {
                params.vendors = `[${values.vendor?.value}]`;
            }
            if (!values.vendor.value) return false;
            try {
                let resp = await getAllTitles(params);
                setResults(resp.data.results);
                setTotal(resp.data.total);
                setPageCount(Math.ceil(resp.data.total / perPage));
                setLoading(false);
                setError(false);
                setRanOnPageLoad(true);
            } catch (err) {
                console.error(err);
                setResults([]);
                setTotal(0);
                setLoading(false);
                setError(err);
            }
        },
        [values]
    );

    let vendorId = values?.vendor?.value;
    let vendorName = values?.vendor?.label;

    useEffect(() => {
        if (!ranOnPageLoad && !session?.isLoading && vendorName && vendorId) {
            fetchTitles(1);
        }
    }, [fetchTitles, ranOnPageLoad, session.isLoading, vendorId, vendorName]);

    const handleAddTitle = (values, { setSubmitting }) => {
        addTitle({
            title: values.title,
            vendorid: session.selectedVendor,
            selectedPublishers: session.user.provider ? session.user.provider.publishers[0] : null,

            asset_plan: 'advanced' // All new titles default to advanced audio management.
        })
            .then((resp) => {
                setSubmitting(false);
                history.push({
                    pathname: `/catalog/${resp.data.id}/metadata`
                });
            })
            .catch((e) => {
                setSubmitting(false);
            });
    };

    const downloadAll = async () => {
        let pubs = null;
        if (values.selectedPublishers.length) {
            pubs = JSON.stringify(values.selectedPublishers);
        }
        setIsDownloading(true);
        let orderBy = values.releaseDateFrom && values.releaseDateTo ? 'original_release_date:desc' : null;
        try {
            const resp = await getAllTitles({
                page: 0,
                per_page: total,
                order_by: orderBy,
                q: values.search || null,
                vendors: `[${values.vendor.value}]`,
                status: values.status || null,
                release_date_0:
                    values.releaseDateFrom && values.releaseDateTo ? values.releaseDateFrom.format('YYYY-MM-DD') : null,
                release_date_1:
                    values.releaseDateFrom && values.releaseDateTo ? values.releaseDateTo.format('YYYY-MM-DD') : null,
                download: true,
                pubs
            });
            saveData(resp.data, `${session.user.provider.name}_catalog_page_${format(new Date(), 'MM-DD-YYYY')}.csv`);
            toast.success('Download ready.');
        } catch (e) {
            const error = e.message || e;
            console.error(error);
            toast.error(`Error: ${error}`);
        }
        setIsDownloading(false);
    };

    const handleSearch = (e) => {
        e.preventDefault();
    };

    const handleSearchChange = (e) => {
        setPage(1);
        setFieldValue('search', e.target.value);
    };

    const handleSearchReset = () => {
        setFieldValue('search', '');
        setPage(1);
    };

    const handleStatusFilter = (id, val) => {
        setPage(1);
        setFieldValue('status', val);
    };

    const handlePublisherFilter = (id, val) => {
        setPage(1);
        setFieldValue(
            'selectedPublishers',
            val.map((p) => p.value)
        );
    };

    const handleVendorFilter = async (id, val, vendors = []) => {
        let vend;
        (vendors || []).map((v) => {
            if (parseInt(v.id) === parseInt(val)) {
                vend = v;
            }
            return null;
        });

        if (vend) {
            let res = await getPubs(val);
            setPage(1);
            setPublishers(res?.data?.filter((pub) => pub) || []);
            setValues({
                ...values,
                vendor: { value: vend.id, label: vend.vendorname },
                // canonical only -- this is what goes out as ?pubs=
                selectedPublishers: (res?.data || []).map(publisherValue).filter((p) => p)
            });
        }
        if (val === 'All') {
            let pubs = [];
            (providers || []).forEach((p) => p.publishers?.forEach((p) => p && pubs.push(p)));
            pubs = (pubs || []).sort((a, b) => sorts.asc(a, b));

            setPublishers(pubs);
            setPage(1);
            setFieldValue('vendor', { value: 'All', label: 'All' });
            setFieldValue('selectedPublishers', []);
        }
    };

    // the 'page' state value does not update quickly and reliably enough to be used in fetchTitles
    // so we pass the page number in directly but also update 'page' state value so that the page
    // numbers display correctly
    const nextPage = () => {
        fetchTitles(page + 1);
        setPage(page + 1);
    };
    const prevPage = () => {
        fetchTitles(page - 1);
        setPage(page - 1);
    };

    const generateStatusBadge = (status) => {
        return <TitleStatusButton status={status} />;
    };

    let readonly = session.isReadOnly;

    // Admin options come from /publishers as {name, display_name}; a provider's own
    // come from tblProvider.publishers as bare strings. publisherOption handles both
    // and always puts the canonical name in `value`.
    let pubs = (session.isAdmin ? publishers : session?.user?.provider?.publishers || [])
        .map(publisherOption)
        .filter((o) => o);

    let vendors = [];
    (providers || []).forEach((p) => p.vendors?.forEach((v) => v.vendorname && vendors.push(v)));

    let vens = (vendors || [])
        .sort((a, b) => sorts.asc(a.vendorname, b.vendorname))
        .map((v) => ({
            label: v.vendorname,
            value: v.id
        }));

    const maxDownloadableTitles = 300;
    const isTotalDownloadable = total <= maxDownloadableTitles;

    return (
        <Layout>
            <div className="page-header">
                <h1 className="collapse">Catalog</h1>
                <div className="flash fixed mb-4 flash-outline-primary sales-flash">
                    <p>
                    We’re moving your older content into the new system—if you don’t see it right away, it’s still on its way!
                    </p>
                </div>
                <p>
                    If you've submitted titles to INaudio using a system besides Passport, you can expect to see them
                    appear here within seven business days.
                </p>
            </div>

            <div className="row mb-5 bottom-sm">
                <div className="col-xs-12 mb-3">
                    <form onSubmit={handleSearch} onReset={handleSearchReset} noValidate>
                        <Input
                            id="search"
                            value={values.search}
                            onChange={handleSearchChange}
                            onKeyPress={(e) => e.key === 'Enter' && fetchTitles(1)}
                            placeholder="Search Title, Author, Narrator, or ISBN."
                            append={
                                <>
                                    {values.search && (
                                        <button className="btn btn-sm btn-muted" type="reset">
                                            &times;
                                        </button>
                                    )}
                                </>
                            }
                            small
                            collapse
                        />
                    </form>
                </div>

                <div className="col-xs col-sm-4">
                    <div className="form-group mb-0">
                        <label className="label-sm" htmlFor="release_date_start">
                            Release Date:
                        </label>
                        <div className="input-group">
                            <DateRangePicker
                                startDatePlaceholderText="From"
                                endDatePlaceholderText="To"
                                startDate={values.releaseDateFrom}
                                startDateId="release_date_start"
                                endDate={values.releaseDateTo}
                                endDateId="release_date_end"
                                isOutsideRange={() => false}
                                onDatesChange={({ startDate, endDate }) => {
                                    setFieldValue('releaseDateTo', endDate);
                                    setFieldValue('releaseDateFrom', startDate);
                                }}
                                focusedInput={focusedInput}
                                onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
                                keepOpenOnDateSelect={false}
                                hideKeyboardShortcutsPanel
                                showClearDates
                                small
                                block
                            />
                        </div>
                    </div>
                </div>

                <div className="col-xs">
                    <MultiSelect
                        id="status"
                        label="Status:"
                        value={values.status || []}
                        options={[
                            { label: 'Drafted', value: 'drafted' },
                            { label: 'Incomplete', value: 'incomplete' },
                            { label: 'Submitted', value: 'submitted' },
                            { label: 'Complete', value: 'complete' },
                            { label: 'Inactive', value: 'inactive' }
                        ]}
                        onChange={handleStatusFilter}
                        hideOptional
                        small
                        collapse
                    />
                </div>
                <div className="col-xs">
                    <MultiSelect
                        id="selectedPublishers"
                        label="Publisher:"
                        value={
                            values.selectedPublishers?.map(
                                (p) => pubs.find((opt) => opt.value === p) || { label: p, value: p }
                            ) || []
                        }
                        options={pubs}
                        onChange={handlePublisherFilter}
                        hideOptional
                        small
                        collapse
                    />
                </div>
                {session?.isAdmin && (
                    <div className="col-xs">
                        <Select
                            id="vendor"
                            label="Vendor:"
                            value={values.vendor.value}
                            options={vens}
                            onChange={(id, val) => handleVendorFilter(id, val, vendors)}
                            placeholder="Select..."
                            className="mb-0"
                            hideOptional={true}
                        >
                            <option value="All">Any Vendor</option>
                            {vens?.map((v, idx) => (
                                <option key={`${v.label}_${v.value}_${idx}`} value={v.value}>
                                    {v.label}
                                </option>
                            ))}
                        </Select>
                    </div>
                )}
                <button className="btn btn-sm btn-secondary" type="submit" onClick={() => fetchTitles(1)}>
                    Refine Search
                </button>

                <div className="col">
                    <button
                        className="btn btn-sm btn-secondary"
                        onClick={downloadAll}
                        disabled={isDownloading || !isTotalDownloadable}
                    >
                        Download{' '}
                        <FaInfoCircle
                            className="ml-1"
                            data-rh={
                                !isTotalDownloadable
                                    ? `Download functionality limited to ${maxDownloadableTitles} title maximum, please adjust your filters and try again.`
                                    : `Download ${total} records as CSV`
                            }
                            data-rh-at="right"
                            size={16}
                        />
                    </button>
                    {!readonly && (
                        <button className="btn btn-sm btn-primary" onClick={(e) => setShowAddModal(true)}>
                            Add Title
                        </button>
                    )}
                </div>
            </div>

            {loading && <Loading />}
            {error && <div className="alert alert-danger">Error! {error.message}</div>}
            {!error && !loading && results && (
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Title: Subtitle</th>
                                <th>Authors</th>
                                <th>Narrators</th>
                                <th>Publisher/Imprint</th>
                                <th>Retail ISBN</th>
                                <th>Library ISBN</th>
                                <th>Release Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!results.length && (
                                <tr>
                                    <td colSpan={8}>No Results.</td>
                                </tr>
                            )}
                            {results.map((node) => {
                                return (
                                    <tr
                                        key={node.id}
                                        className={classnames({
                                            inactive: !node.active
                                        })}
                                    >
                                        <td data-title="Status: ">{generateStatusBadge(node.status)}</td>
                                        <td data-title="Title: Subtitle: ">
                                            <Link to={`/catalog/${node.id}/metadata`}>
                                                {node.title}
                                                {node.subtitle && <span className="text-muted">: {node.subtitle}</span>}
                                            </Link>
                                        </td>
                                        <td data-title="Authors: ">
                                            <AuthorList authors={node.authors || []} limit={1} />
                                        </td>
                                        <td data-title="Narrators: ">
                                            <AuthorList authors={node.narrators || []} limit={1} />
                                        </td>
                                        <td data-title="Publisher/Imprint: ">
                                            {publisherLabel(node) || node.imprint || 'NONE'}
                                        </td>
                                        <td data-title="Retail ISBN: ">{node.isbn_retail}</td>
                                        <td data-title="Library ISBN: ">{node.isbn_library}</td>
                                        <td data-title="Release Date: ">
                                            {node.original_release_date
                                                ? format(node.original_release_date || '', 'M/DD/YYYY')
                                                : 'Not Set'}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {!!results.length && <Pagination page={page} pageCount={pageCount} onNext={nextPage} onPrev={prevPage} />}

            <div>
                <h4>Status Glossary</h4>
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="badge badge-secondary">Inactive</div>
                                </td>
                                <td>INaudio does not currently have rights to sell this title</td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="badge badge-warning">Drafted</div>
                                </td>
                                <td>Title is in draft mode in Passport, and has not been sent to INaudio</td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="badge badge-danger">Incomplete</div>
                                </td>
                                <td>Metadata has been submitted to INaudio, but Art and/or Audio are missing</td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="badge badge-primary-blue">Submitted</div>
                                </td>
                                <td>
                                    The full audiobook title has been submitted to INaudio, and has passed our
                                    automated QC.
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="badge badge-success">Complete</div>
                                </td>
                                <td>
                                    The full audiobook title has been successfully ingested into INaudio’s systems.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {!readonly && (
                <Modal label="Add Title" visible={showAddModal} onClose={(e) => setShowAddModal(false)}>
                    <h2>Add Title</h2>
                    <Formik
                        validationSchema={object().shape({ title: string().required() })}
                        initialValues={{ title: '' }}
                        onSubmit={handleAddTitle}
                    >
                        {({ values, handleSubmit, errors, touched, handleChange, isSubmitting }) => (
                            <form onSubmit={handleSubmit} noValidate>
                                <Input
                                    id="title"
                                    label="Title"
                                    value={values.title}
                                    onChange={handleChange}
                                    errors={errors.title}
                                    touched={touched.title}
                                    required
                                />
                                <button className="btn btn-primary" type="submit" disabled={isSubmitting}>
                                    {isSubmitting ? 'Adding...' : 'Add'}
                                </button>
                                <button
                                    className="btn btn-tertiary"
                                    type="button"
                                    disabled={isSubmitting}
                                    onClick={(e) => setShowAddModal(false)}
                                >
                                    Cancel
                                </button>
                            </form>
                        )}
                    </Formik>
                </Modal>
            )}
        </Layout>
    );
};

export default Catalog;
